import React from "react";
import { Routes, Route } from "react-router-dom";
import HomeAI from "../pages/SettingsAi/Home";
import { AiRegiProvider } from "../pages/SettingsAi/QuickRegister/Context/AiRegiContext"; // importe o provider
import SettingsFastReg from "../pages/SettingsAi/QuickRegister/SettingsFastReg";
import DetailsAI from "../pages/SettingsAi/DetailsAI";

const AIroutes = () => (
  <Routes>
    <Route
      path="/quickRegister"
      element={
        <AiRegiProvider>
          <SettingsFastReg />
        </AiRegiProvider>
      }
    />
  </Routes>
);

export default AIroutes;
